import React, { FC } from 'react';
import { Row } from 'antd';
import { Formik, Form as FormikForm } from 'formik';
import Logo from 'assets/logo/logo_full.png';
import InputField from 'shared/components/InputField';
import COButton from 'shared/components/COButton';
import styles from './LoginForm.module.scss';
import { Fields, initialValues, validationSchema } from './LoginFormConstants';
import { LoginFormProps } from 'enums/LoginFormEnums';
import AuthenticationService from 'services/AuthenticationService/authentication.service';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from 'routes/routeConstants/appRoutes';

interface LoginFormValues {
  email: string;
  password: string;
}

const LoginView: FC = () => {
  const { adminLogin, buttonLoading } = AuthenticationService();
  const navigate = useNavigate();

  const handleSignupRedirection = () => navigate(AppRoutes.ADMIN_INFO);

  const handleForgotPasswordRedirection = () => navigate(AppRoutes.FORGOT_PASS);

  const handleApiSubmission = (values: LoginFormValues) =>
    adminLogin({
      email: values.email,
      password: values.password,
    });

  return (
    <div className={styles.formContainer}>
      <Row className={styles.logoContainer}>
        <img
          src={Logo}
          alt={LoginFormProps.IMAGE_ALT}
          className={styles.logo}
        />
      </Row>
      <Row className={styles.headingContainer}>
        <div>
          <h1>{LoginFormProps.HEADING}</h1>
        </div>
        <div>
          <h2>
            {LoginFormProps.SUBHEADING}{' '}
            <span className={styles.spanText} onClick={handleSignupRedirection}>
              {LoginFormProps.SUBHEADING_SPAN}
            </span>
          </h2>
        </div>
      </Row>
      <div className={styles.fieldsContainer}>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={values => handleApiSubmission(values)}>
          {formik => (
            <FormikForm>
              {Fields.map((field, index) => {
                return (
                  <div key={index} className={styles.fieldContainer}>
                    <InputField
                      name={field.name}
                      placeholderstring={field.placeholder}
                      label={field.label}
                      password={field.password}
                    />
                    {field.helper && (
                      <div className={styles.helpercontainer}>
                        <span
                          className={styles.spanText}
                          onClick={handleForgotPasswordRedirection}>
                          {LoginFormProps.HELPER_TEXT}
                        </span>
                      </div>
                    )}
                  </div>
                );
              })}

              <div className={styles.buttonContainer}>
                <COButton
                  submit
                  loading={buttonLoading}
                  disabled={!formik.isValid}>
                  {LoginFormProps.BUTTON_LABEL_SUBMIT}
                </COButton>
              </div>
            </FormikForm>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default LoginView;
